export const GENDER = [
    {
        value: 15,
        label: 'Male'
    },
    {
        value: 16,
        label: 'Female'
    },
    {
        value: 17,
        label: 'Non-Binary'
    },
    {
        value: 18,
        label: 'Prefer not to say'
    }
];
